import { Component, Input, Output, Inject, ViewChild, OnDestroy, EventEmitter, OnInit } from '@angular/core';
import { User }                                                                            from '../../models/user';
import { UserService }                                                                     from '../../services/user.service';
import { Router }                                                                          from '@angular/router';
import { Location }                                                                        from '@angular/common';
import { Subject }                                                                         from 'rxjs/Subject';
import { Observable }                                                                      from 'rxjs';
import { AngularFireDatabase, FirebaseListObservable }                                     from 'angularfire2/database';
import { BrowserModule }                                                                   from '@angular/platform-browser'
import { ImageCropperComponent, CropperSettings, Bounds }                                  from 'ng2-img-cropper';
import { ModalDirective }                                                                  from 'ng2-bootstrap/modal';
import * as firebase from 'firebase';

interface Image {
  path: string;
  filename: string;
  downloadURL?: string;
  $key?: string;
}

@Component({
  selector: 'profile-edit',
  templateUrl: './profile-edit.component.html',
  styleUrls: [ './profile-edit.component.scss' ]
})
export class ProfileEditComponent implements OnInit {

  data1: any;
  cropperSettings1: CropperSettings;
  croppedWidth: number;
  croppedHeight: number;
  firebaseApp: any;
  private user: User;

  @ViewChild('cropper', undefined) cropper: ImageCropperComponent;
  @ViewChild('modal') modal: ModalDirective;
  @Output() profileEdited: EventEmitter<any> = new EventEmitter();

  constructor(
    private userService: UserService,
    private db: AngularFireDatabase) {

    this.cropperSettings1 = new CropperSettings();
    this.cropperSettings1.width = 500;
    this.cropperSettings1.height = 500;
    this.cropperSettings1.croppedWidth = 500;
    this.cropperSettings1.croppedHeight = 500;
    this.cropperSettings1.canvasWidth = 250;
    this.cropperSettings1.canvasHeight = 250;
    this.cropperSettings1.minWidth = 10;
    this.cropperSettings1.minHeight = 10;
    this.cropperSettings1.rounded = false;
    this.cropperSettings1.keepAspect = true;
    this.cropperSettings1.cropperDrawSettings.strokeColor = 'rgba(255,0,255,1)';
    this.cropperSettings1.cropperDrawSettings.strokeWidth = 2;
    this.data1 = {};
  }

  ngOnInit(): void { }

  base64toFile(base64) {
    var arr = base64.split(',')
    var mime = arr[0].match(/:(.*?);/)[1]
    var bstr = atob(arr[1])
    var n = bstr.length
    var u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], 'profile', { type: mime });
  }

  upload() {
    let storageRef = firebase.storage().ref();
    let selectedFile = this.base64toFile(this.data1.image);
    var iRef = storageRef.child(`/users/${this.user.id}/${selectedFile.name}`);
    iRef.put(selectedFile).then((snapshot) => {
      this.user.url = snapshot.downloadURL;
      this.userService.update(this.user).subscribe(
        user => {
          this.profileEdited.emit(user);
          this.modal.hide();
        }
      )
    });

  }

  cropped(bounds: Bounds) {
    this.croppedHeight = 250;
    this.croppedWidth = 250;
  }

  show(id: string): void {
    this.userService.getUser(id).subscribe(
      user => {
        this.user = user;
      }
    );
    this.modal.show();
  }

  fileChangeListener($event) {
    var image: any = new Image();
    var file: File = $event.target.files[0];
    var myReader: FileReader = new FileReader();
    var that = this;
    myReader.onloadend = function(loadEvent: any) {
      image.src = loadEvent.target.result;
      that.cropper.setImage(image);
    };
    myReader.readAsDataURL(file);
  }
}



// WEBPACK FOOTER //
// ./src/app/users/components/profile-edit/profile-edit.component.ts